import { FULL_PERCENT } from '@hooks/constants';
import { useQuery } from '@hooks/reactQuery';

import { fetchHistoryCheckBranches } from '@api/hitoryCheck';

import { TCMBranches } from '@interfaces/cmModule/cmModule';
import { IHistoryCheckBranchesFetchDTO } from '@interfaces/cmModule/dto/historyCheckDTO';
import { TPartialPick } from '@interfaces/common/genericWithModifying';
import { IProgressBranches } from '@interfaces/import/import';

import { refetchOptions } from '@constants/common';
import { HISTORY_CHECK_BRANCHES_FETCH } from '@constants/queryKeys';

type TUseQueryHistoryCheckBranches = {
	progress?: IProgressBranches;
	progressId?: string;
} & TPartialPick<IHistoryCheckBranchesFetchDTO, 'dumpHistoryId'>

export const useQueryHistoryCheckBranches = (params: TUseQueryHistoryCheckBranches) => {
	const {
		page,
		pageSize,
		sortDirection,
		sortFieldName,
		searchValue,
		progressId,
		progress,
	} = params;

	const dumpId = progress?.dumpId || null;

	const isFullProgress = progressId === progress?.id && progress?.percentsProgress === FULL_PERCENT;

	const {
		data: branchData,
		isLoading: isLoadingBranchData,
		isFetching: isFetchingBranchData,
	} = useQuery<TCMBranches | undefined>({
		queryKey: [
			HISTORY_CHECK_BRANCHES_FETCH,
			page,
			pageSize,
			sortDirection,
			sortFieldName,
			searchValue,
			dumpId,
			progressId,
			progress,
		],
		queryFn: () => {
			if (isFullProgress) {
				return fetchHistoryCheckBranches({
					pageSize,
					page,
					sortDirection,
					sortFieldName,
					searchValue,
					dumpHistoryId: dumpId!,
				});
			}
		},
		enabled: [
			!!dumpId,
			!!pageSize,
			!!page,
			isFullProgress,
		],
		...refetchOptions,
	});

	return {
		branchData,
		isLoadingBranchData: (isLoadingBranchData && !!branchData)
			|| isFetchingBranchData,
		isFetchingBranchData,
	};
};
